if (!customElements.get("comp-waitlist")) {
  class CompWaitlist extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSelectors();
      this.bindEvents();
    }

    initSelectors() {
      this.forms = [...this.querySelectorAll('[data-js-bis-form]')];
      this.email = this.querySelector('[name="waitlist-email"]');
      this.phone = this.querySelector('[name="waitlist-phone"]');

      this.productId = this.querySelector('[name="waitlist-product-id"]')
      this.variantId = this.querySelector('[name="waitlist-variant-id"]');
      this.toggles = [...this.querySelectorAll('[name="switch-waitlist"]')];

      this.acceptsMarketing = this.querySelector('[name="accepts_marketing"]');

      this.errorMessage = this.querySelector('[data-error-message]')
      this.successMessage = this.querySelector('[data-success-message]')
    }

    bindEvents() {
      this.toggles.forEach(radio => {
        radio.addEventListener('change', (e) => {
          const target = this.querySelector(`[data-js-bis-form-${e.target.value}]`);
          this.forms.forEach((el) => el.classList.add('hide'));
          if (target) {
            target.classList.remove('hide');
          }
        });
      })


      this.forms.forEach((form) => {
        form.addEventListener('submit', (e) => this._handleSubmit(e));
      })
    }

    _handleSubmit(e) {
      e.preventDefault();
    
      loadingBarTrigger('start');
  
      const callback = (data) => {
        var msg = '';
        loadingBarTrigger('done');
  
        if (data.status == 'OK') {
          this.errorMessage.classList.remove('show')
          this.classList.add('success');
        } else {
          const errorMessage = data.errors.variantId || data.errors.base[0] || data.errors.phone_number[0]
          this.errorMessage.textContent = errorMessage;
          this.errorMessage.classList.add('show')
        }
      }
  
      const switchValue = this.querySelector('[name="switch-waitlist"]:checked')?.value || 'email';
      const variantId = this.variantId.value
      const productId = this.productId.value
      let acceptsMarketing = this.acceptsMarketing.checked
  
      if (switchValue == 'email') {
        if (!this.email.value || !this.validateEmail(this.email.value)) {
          if (this.querySelector('.newsletter-email-field')) {
            this.querySelector('.newsletter-email-field').classList.add('error');
          }
        } else {
          BIS.create(this.email.value, variantId, productId, {
            accepts_marketing: acceptsMarketing
          }).then((data) => callback(data));
        }
      } else {
        if (!this.phone.value) {
        } else {
          BIS.create(null, variantId, productId, {
            phone_number: `+1${this.phone.value}`
          }).then((data) => callback(data));
        }
      }
    }

    validateEmail(email) {
      let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(email);
    }
  }

  customElements.define("comp-waitlist", CompWaitlist);
}
